module.exports = __webpack_public_path__ + "img/cpyh.053c6af9.png";